export default {
      id: "73,4-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#73,4",
      toString: function () {
        return this.url;
      }
    }